export default __webpack_public_path__ + "static/10_19-95d86f3efbec4d452ed1f80d9db99168.png";